module.exports = __webpack_public_path__ + "assets/app8header.89c238a6.svg";